<template>
  <source
    src="#"
    :srcset="src"
    :media="media"
    :type="typeImage"
  >
</template>
<script>
export default {
  name: 'v-picture-source',
  props: {
    value: {
      type: [Object, Array],
      default() {
        return {};
      },
    },
    mediaProp: {
      type: [Number, String],
      default: '*',
    },
    typeImage: {
      type: String,
      default: '',
    },
  },
  computed: {
    media() {
      return this.mediaProp !== '*' ? `(max-width: ${this.mediaProp}px)` : '';
    },
    src() {
      if (this.typeImage) {
        return this.value.webp;
      }
      return this.value.src;
    },
  },
};
</script>
